import { StyleRules, WithStyles, withStyles as withStylesCb } from "@material-ui/core/styles";

export const styles: StyleRules = {
  ul: {
    padding: 0
  },
  li: {
    listStyleType: "none"
  }
};

export type Styles = WithStyles<typeof styles>;
export const withStyles = withStylesCb(styles);
